var _rect, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditAnalysisProject(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 40,
    rx: 8,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8477 9.87868C35.6761 8.70711 33.7766 8.7071 32.605 9.87868L18.4474 24.0363C18.0286 24.4551 17.7432 24.9885 17.627 25.5692L17.04 28.5046C16.7601 29.904 17.9939 31.1379 19.3933 30.858L22.3287 30.2709C22.9095 30.1548 23.4429 29.8693 23.8616 29.4505L38.0192 15.2929C39.1908 14.1213 39.1908 12.2218 38.0192 11.0502L36.8477 9.87868ZM34.0192 11.2929C34.4098 10.9024 35.0429 10.9024 35.4335 11.2929L36.605 12.4645C36.9956 12.855 36.9956 13.4881 36.605 13.8787L33.9334 16.5503L31.3477 13.9645L34.0192 11.2929ZM29.9334 15.3787L19.8617 25.4505C19.7221 25.5901 19.6269 25.7679 19.5882 25.9615L19.0011 28.8968L21.9365 28.3097C22.13 28.271 22.3078 28.1759 22.4474 28.0363L32.5192 17.9645L29.9334 15.3787Z",
    fill: "#8F8F8F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAnalysisProject);
export default __webpack_public_path__ + "static/media/edit-analysis-project.a0dc72b40259c7e2a0bee18c049f1ffe.svg";
export { ForwardRef as ReactComponent };